// Action Creators
import { ActionCreator } from "@ms/planner-actioncreators/lib/local/actioncreators/ActionCreator";
import { MetaOSAppActionCreatorLoader } from "./MetaOSAppActionCreatorLoader";
/**
 * Loader class for loading action creators in the Teams app
 */
export class TeamsAppActionCreatorLoader extends MetaOSAppActionCreatorLoader {
    /**
     * Constructor for BaseActionCreatorLoader
     * @param configProvider Config provider for constants
     * @param dispatcher Action dispatcher
     * @param loader Component loader
     * @param logicModuleLoader Logic module loader
     * @param loggers Logger context for telemetry
     * @param storeLoader Store loader
     */
    constructor(configProvider, dispatcher, loader, logicModuleLoader, loggers, storeLoader, teamsAdaptor) {
        super(configProvider, dispatcher, loader, logicModuleLoader, loggers, storeLoader);
        this.teamsAdaptor = teamsAdaptor;
    }
    loadTeamsTabActionCreator() {
        return this.loader.load(this.getActionCreatorBundleKey(ActionCreator.TeamsTab), () => import(
        /* webpackChunkName: "planner-teamstabac" */ "@ms/planner-actioncreators/lib/local/actioncreators/teamsTab/TeamsTabActionCreator"), (bundle) => new bundle.TeamsTabActionCreator(this.logicModuleLoader, this.storeLoader, this.loggers, this.teamsAdaptor, this.configProvider));
    }
    loadCreateTeamsTabViewActionCreator() {
        return this.loader.load(this.getActionCreatorBundleKey(ActionCreator.CreateTeamsTabView), () => import(
        /* webpackChunkName: "planner-createteamstabviewac" */ "@ms/planner-actioncreators/lib/local/actioncreators/view/CreateTeamsTabViewActionCreator"), (bundle) => new bundle.CreateTeamsTabViewActionCreator(this.logicModuleLoader, this.loggers, this.teamsAdaptor, this.configProvider));
    }
}
